if (!customElements.get('product-description-read-more')) {
  customElements.define(
    'product-description-read-more',
    class ProductDescriptionReadMore extends HTMLElement {
      connectedCallback() {
        this.content = this.querySelector('.product-description-read-more__content');
        this.toggle = this.querySelector('.product-description-read-more__toggle');
        this.collapsedMaxHeight = this.dataset.collapsedMaxHeight || '16';

        if (!this.content || !this.toggle) return;

        this.toggle.addEventListener('click', this.onToggle.bind(this));
        this.content.addEventListener('transitionend', this.onTransitionEnd.bind(this));
      }

      onToggle() {
        const expanded = this.toggle.getAttribute('aria-expanded') === 'true';

        if (expanded) {
          this.collapse();
        } else {
          this.expand();
        }
      }

      expand() {
        this.content.style.maxHeight = `${this.content.scrollHeight}px`;
        this.content.classList.add('is-expanded');
        this.toggle.setAttribute('aria-expanded', 'true');
        this.toggle.textContent = this.toggle.dataset.readLess;
      }

      collapse() {
        this.content.style.maxHeight = `${this.content.scrollHeight}px`;

        requestAnimationFrame(() => {
          this.content.classList.remove('is-expanded');
          this.content.style.maxHeight = `${this.collapsedMaxHeight}rem`;
        });

        this.toggle.setAttribute('aria-expanded', 'false');
        this.toggle.textContent = this.toggle.dataset.readMore;
      }

      onTransitionEnd(event) {
        if (event.propertyName !== 'max-height') return;
        if (!this.content.classList.contains('is-expanded')) return;

        this.content.style.maxHeight = 'none';
      }
    }
  );
}
